import React from 'react';
import { CtaBlock, CtaGuaranteeRow } from './CtaBlock';
import { HERO_IMAGE } from '../data/content';
const highlights = ['6 Volumi clinici', '300+ Protocolli', 'Algoritmi decisionali', '30+ Casi risolti', '5 Bonus pratici'];
export function FinalCta() {
  return <section className="bg-navy-900 py-14 sm:py-20" data-id="element-145" data-mp="15ddkhfl5o7m6">
      <div className="mx-auto w-full max-w-3xl px-4 text-center sm:px-6" data-id="element-146" data-mp="15bsnljbdccl5">
        <h2 className="text-balance text-[26px] font-black uppercase leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-147" data-mp="1jcd9iockyoiv">
          Smetti di cercare. <span className="text-gold-400" data-id="element-148" data-mp="1ebxvrvodzf0d">Inizia a usare un sistema.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-white/70" data-id="element-149" data-mp="1t253phgrpfmt">
          Puoi continuare ad aprire più linee guida ogni volta che emerge una
          domanda sulla TRT. Oppure puoi organizzare il processo intorno a un
          unico sistema clinico pratico.
        </p>

        <img src={HERO_IMAGE} alt="Sistema Maestro della TRT™ su computer, tablet e smartphone" className="mx-auto mt-8 w-full max-w-sm" width={1080} height={1080} loading="lazy" data-id="element-150" data-mp="1x6curlap77o7" />

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-151" data-mp="x390dvx3m26f">
          {highlights.map(item => <li key={item} className="rounded-full border border-white/15 bg-white/[0.06] px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white/80" data-id="element-152" data-mp="123woa8q162wf">
              {item}
            </li>)}
        </ul>

        <p className="mt-6 text-[13px] font-black uppercase tracking-[0.14em] text-gold-300" data-id="element-153" data-mp="1fujns33m7wtk">
          Tutto per 19 EUR
        </p>

        <div className="mt-6 flex justify-center" data-id="element-154" data-mp="1ksbfox49fixr">
          <CtaBlock tone="dark" label="Ottieni ora il Sistema Maestro — 19 EUR" note="La tua prossima visita TRT non deve iniziare con una ricerca su Google" showScarcity data-id="element-155" data-mp="1kv7gqubemnqf" />
        </div>
        <div className="mt-5" data-id="element-156" data-mp="3qvqidrtugwkb">
          <CtaGuaranteeRow tone="dark" data-id="element-157" data-mp="3qux8wj3i3syh" />
        </div>
      </div>
    </section>;
}